module.exports = __webpack_public_path__ + "img/insertLinkWhite.df200254.svg";